import {
  VERIFY_USER_REQUEST,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_FAILURE
} from 'constants/actionTypes';

export function verifyUser(verificationToken) {
  return {
    type: VERIFY_USER_REQUEST,
    verificationToken
  };
}

export function verifyUserSuccess(user) {
  return {
    type: VERIFY_USER_SUCCESS,
    user
  };
}

export function verifyUserFailure(reason) {
  return {
    type: VERIFY_USER_FAILURE,
    reason
  };
}